module.exports = require("npm:js-yaml@3.6.0/index");